import transformGridItems from 'redux/transforms/transform-grid-items';
import { transformProductIntoLegacyFormat } from './transform-product-into-legacy-format';

const newTransformInterstitialsContent = (alldata = {}) => {
  const { content = {}, steps, products } = alldata;

  return {
    ...transformGridItems({
      ...content,
      ...(products?.length && {
        componentsAndProducts: products.map(product => transformProductIntoLegacyFormat(product)),
      }),
    }),
    interstitials: {
      currentStep: steps && steps[0]?.id,
      steps,
    },
  };
};

export default newTransformInterstitialsContent;
